import { Container, Row, Col, Card, ProgressBar, Table, Badge, Button } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { toast, ToastContainer } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DeviceListInReportModal from "./modals/deviceListInReport";
import DevicesInWrongShopsModal from "./modals/devicesInWrongShopsModal";
import ReportListSidebar from "./reports/reportListSidebar";
import ReportHeader from "./reports/reportHeader";
import SectionToggleControls from "./reports/sectionToggleControls";
import ShopStatusSection from "./reports/shopStatusSection";
import PlaylistStatusSection from "./reports/playlistStatusSection";
import DeviceHealthSection from "./reports/deviceHealthSection";
import TagsAnalysisSection from "./reports/tagsAnalysisSection";
import { 
  faFileAlt, 
  faCalendarAlt, 
  faCheckCircle, 
  faTimesCircle, 
  faExclamationTriangle,
  faMicrochip,
  faSignal,
  faChartBar,
  faMusic,
  faTag
} from "@fortawesome/free-solid-svg-icons";
import StatusReportService from "../services/statusReportService";
import "react-toastify/dist/ReactToastify.css";

// Custom styles
const customStyles = `
    .report-list-item:hover {
        background-color: #f8f9fa !important;
        transition: all 0.2s ease;
        
    }
    
    .report-card {
        transition: all 0.3s ease;
        border: none;
    }
    
    .report-card:hover {
        box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
    }
    
    .active-report {
        background: linear-gradient(45deg, #bdbec0ff, #909296ff) !important;
        color: white !important;
    }

    .active-report:hover {
        background: linear-gradient(45deg, #0d78d6ff, #0d78d6ff) !important;
        color: white !important;
    }
    
    .active-report .text-muted {
        color: rgba(255, 255, 255, 0.8) !important;
    }
    
    .active-report .text-primary {
        color: white !important;
    }

    .inactive-report {
        color: white !important;
    }

    .inactive-report:hover {
        background: linear-gradient(45deg, #0d78d6ff, #0d78d6ff) !important;
        color: white !important;
    }
    
    .inactive-report:hover .text-muted {
        color: rgba(255, 255, 255, 0.8) !important;
    }
    
    .inactive-report .text-primary {
        color: white !important;
    }
    
    .reports-list-container {
        max-height: 60vh;
        overflow-y: auto;
    }
    
    @media (max-width: 767.98px) {
        .reports-list-container {
            max-height: 30vh;
        }
    }
    
    .reports-list-container::-webkit-scrollbar {
        width: 8px;
    }
    
    .reports-list-container::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
    }
    
    .reports-list-container::-webkit-scrollbar-thumb {
        background: #6c757d;
        border-radius: 4px;
    }
    
    .reports-list-container::-webkit-scrollbar-thumb:hover {
        background: #495057;
    }

    .report-details .card {
        border: 1px solid #e3e6f0;
        border-radius: 0.35rem;
    }

    .report-details .progress {
        background-color: #f8f9fc;
    }

    .report-details .badge {
        font-size: 0.75em;
    }

    /* Clickable badge styles */
    .badge.clickable-badge {
        cursor: pointer !important;
        transition: all 0.2s ease !important;
        position: relative !important;
        border: 1px solid transparent !important;
    }

    .badge.clickable-badge:hover {
        transform: translateY(-1px) !important;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
        filter: brightness(1.1) !important;
    }

    .badge.clickable-badge:active {
        transform: translateY(0px) !important;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
    }

    /* Add a small click indicator icon */
    .badge.clickable-badge::after {
        content: "👆";
        font-size: 0.6em;
        margin-left: 4px;
        opacity: 0.7;
    }

    .badge.clickable-badge:hover::after {
        opacity: 1;
    }

    .report-details .table th {
        border-top: none;
        font-weight: 600;
        font-size: 0.85em;
        color: #5a5c69;
    }

    .report-details .table td {
        font-size: 0.85em;
        vertical-align: middle;
    }

    .report-details .small {
        font-size: 0.75em;
    }

    .report-details .border {
        border-color: #e3e6f0 !important;
    }

    .report-details .text-primary {
        color: #5a67d8 !important;
    }

    .report-details .bg-secondary {
        background-color: #6c757d !important;
    }

    .report-details .alert {
        font-size: 0.85em;
    }

    .report-details .sticky-top {
        position: sticky;
        top: 0;
        z-index: 10;
    }

    .report-details .border-end {
        border-right: 1px solid #dee2e6 !important;
    }

    .report-details .gap-1 {
        gap: 0.25rem !important;
    }

    .report-details .text-truncate {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    @media (max-width: 767.98px) {
        .report-details .border-end {
            border-right: none !important;
            border-bottom: 1px solid #dee2e6 !important;
            padding-bottom: 0.75rem !important;
            margin-bottom: 0.75rem !important;
        }
        
        .report-details .ps-3 {
            padding-left: 0 !important;
        }
        
        .report-details .pe-3 {
            padding-right: 0 !important;
        }
    }
`;

function Reports() {
  const [reportsList, setReportsList] = useState([]);
  const [selectedReport, setSelectedReport] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  
  // Modal state for shop lists
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({
    title: '',
    shops: [],
    type: ''
  });

  // Modal state for devices in wrong shops
  const [showDevicesModal, setShowDevicesModal] = useState(false);
  const [devicesModalData, setDevicesModalData] = useState({
    title: '',
    devices: []
  });

  // Section visibility states
  const [sectionVisibility, setSectionVisibility] = useState({
    shopStatus: false,
    deviceHealth: false,
    playlistStatus: false,
    tagsAnalysis: false
  });

  // Date filtering states
  const [dateFilter, setDateFilter] = useState({
    startDate: '',
    endDate: ''
  });
  const [filteredReportsList, setFilteredReportsList] = useState([]);

  const getList = async () => {
    setIsLoading(true);
    try {
      const response = await StatusReportService.getList();
      setReportsList(response.data);
      console.log("Fetched reports:", response.data);
    } catch (err) {
      console.error("Error fetching reports:", err);
      toast.error("Błąd podczas pobierania raportów", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
        pauseOnFocusLoss: false,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleReportSelect = async (_id) => {
    try {
      const {data: report} = await StatusReportService.get(_id);
      console.log("Fetched report details:", report);
      setSelectedReport(report);
    } catch (err) {
        console.error("Error fetching report:", err);
        toast.error("Błąd podczas pobierania raportu", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 3000,
            pauseOnFocusLoss: false,
        });
    }
  };

  // Handle opening modal with shop list
  const handleShopListModal = (title, shops, type) => {
    setModalData({
      title,
      shops: shops || [],
      type
    });
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setModalData({ title: '', shops: [], type: '' });
  };

  // Handle opening modal with devices in wrong shops
  const handleDevicesInWrongShopsModal = (title, devices) => {
    setDevicesModalData({
      title,
      devices: devices || []
    });
    setShowDevicesModal(true);
  };

  const handleCloseDevicesModal = () => {
    setShowDevicesModal(false);
    setDevicesModalData({ title: '', devices: [] });
  };

  // Toggle section visibility
  const toggleSection = (sectionName) => {
    setSectionVisibility(prev => ({
      ...prev,
      [sectionName]: !prev[sectionName]
    }));
  };

  // Toggle all sections
  const toggleAllSections = (visible) => {
    setSectionVisibility({
      shopStatus: visible,
      deviceHealth: visible,
      playlistStatus: visible,
      tagsAnalysis: visible
    });
  };

  // Date filtering functions
  const handleDateFilterChange = (field, value) => {
    setDateFilter(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const clearDateFilter = () => {
    setDateFilter({
      startDate: '',
      endDate: ''
    });
  };

  useEffect(() => {
    getList();
  }, []);

  // Effect to filter reports based on date range
  useEffect(() => {
    if (!dateFilter.startDate && !dateFilter.endDate) {
      setFilteredReportsList(reportsList);
    } else {
      const filtered = reportsList.filter(report => {
        const reportDate = new Date(report.addedAt);
        const startDate = dateFilter.startDate ? new Date(dateFilter.startDate) : null;
        const endDate = dateFilter.endDate ? new Date(dateFilter.endDate + 'T23:59:59') : null;
        
        if (startDate && endDate) {
          return reportDate >= startDate && reportDate <= endDate;
        } else if (startDate) {
          return reportDate >= startDate;
        } else if (endDate) {
          return reportDate <= endDate;
        }
        return true;
      });
      setFilteredReportsList(filtered);
    }
  }, [reportsList, dateFilter]);

  return (
    <React.Fragment>
      <style>{customStyles}</style>
      <Breadcrumb style={{ backgroundColor: "#DDDDDD" }}>
        <Breadcrumb.Item
          style={{
            marginTop: 3,
            marginLeft: 3,
            marginBottom: 3,
            marginRight: 0,
          }}
          href="/"
        >
          Home
        </Breadcrumb.Item>
        <Breadcrumb.Item
          style={{
            marginTop: 3,
            marginLeft: 3,
            marginBottom: 3,
            marginRight: 0,
          }}
          href="/"
          active
        >
          Raportowanie
        </Breadcrumb.Item>
        <Breadcrumb.Item
          style={{
            marginTop: 3,
            marginLeft: 3,
            marginBottom: 3,
            marginRight: 0,
          }}
          active
        >
          Raporty
        </Breadcrumb.Item>
      </Breadcrumb>
      <div className="App">
        <div>
          <ToastContainer />
        </div>
        <Container fluid>
          <Row>
            <Col md={3}>
              <ReportListSidebar
                reportsList={reportsList}
                filteredReportsList={filteredReportsList}
                selectedReport={selectedReport}
                isLoading={isLoading}
                dateFilter={dateFilter}
                onReportSelect={handleReportSelect}
                onDateFilterChange={handleDateFilterChange}
                onClearDateFilter={clearDateFilter}
              />
            </Col>
            <Col md={9}>
              {selectedReport ? (
                <div className="report-details">
                  {/* Header Card */}
                  <ReportHeader selectedReport={selectedReport} />

                  {/* Section Control Panel */}
                  <SectionToggleControls
                    sectionVisibility={sectionVisibility}
                    onToggleSection={toggleSection}
                    onToggleAllSections={toggleAllSections}
                  />

                  {/* Shop Status Overview - Critical First */}
                  <ShopStatusSection
                    selectedReport={selectedReport}
                    sectionVisibility={sectionVisibility}
                    onToggleSection={toggleSection}
                    onHandleShopListModal={handleShopListModal}
                  />

                  

                 
                  {/* Playlist Status Section (IMS + MA) */}
                  <PlaylistStatusSection 
                    selectedReport={selectedReport}
                    sectionVisibility={sectionVisibility}
                    handleShopListModal={handleShopListModal}
                  />

           

                  {/* Device Health Status */}
                  <DeviceHealthSection 
                    selectedReport={selectedReport}
                    sectionVisibility={sectionVisibility}
                    handleShopListModal={handleShopListModal}
                  />

                 

                  {/* Tags Analysis - Separate Section */}
                  <TagsAnalysisSection 
                    selectedReport={selectedReport}
                    sectionVisibility={sectionVisibility}
                  />

                </div>
              ) : (
                <Card className="shadow-sm report-card h-100">
                  <Card.Body className="d-flex align-items-center justify-content-center text-center">
                    <div>
                      <FontAwesomeIcon
                        icon={faFileAlt}
                        size="3x"
                        className="text-muted mb-3"
                      />
                      <h5 className="text-muted">Wybierz raport z listy</h5>
                      <p className="text-muted">Kliknij na raport z lewej strony, aby zobaczyć jego szczegóły</p>
                    </div>
                  </Card.Body>
                </Card>
              )}
            </Col>
          </Row>
        </Container>

        {/* Shop List Modal */}
        <DeviceListInReportModal 
          show={showModal} 
          onHide={handleCloseModal} 
          modalData={modalData}
        />

        {/* Devices in Wrong Shops Modal */}
        <DevicesInWrongShopsModal 
          show={showDevicesModal} 
          onHide={handleCloseDevicesModal} 
          modalData={devicesModalData}
        />
      </div>
    </React.Fragment>
  );
}

export default Reports;
